// Megamenu Collection Hover Effect with Product Image Rotation
(function() {
  'use strict';

  let imageRotationInterval = null;
  let currentImageIndex = 0;

  document.addEventListener('DOMContentLoaded', function() {
    initMegamenuCollectionHover();
  });

  function initMegamenuCollectionHover() {
    const megamenuContainers = document.querySelectorAll('.meganav');
    
    if (megamenuContainers.length === 0) {
      return;
    }

    megamenuContainers.forEach((container) => {
      const megamenuLinks = container.querySelectorAll('.megamenu-collection-link');
      const megamenuItems = container.querySelectorAll('.megamenu-collection-item');

      if (megamenuItems.length === 0 || megamenuLinks.length === 0) {
        return;
      }

      // Add hover listeners to each link
      megamenuLinks.forEach((link) => {
        link.addEventListener('mouseenter', function() {
          const allCards = Array.from(megamenuItems);
          startImageRotation(allCards);
        });

        link.addEventListener('mouseleave', function() {
          stopImageRotation();
        });
      });

      // Also add hover to collection items themselves
      megamenuItems.forEach((item) => {
        item.addEventListener('mouseenter', function() {
          const allCards = Array.from(megamenuItems);
          startImageRotation(allCards);
        });

        item.addEventListener('mouseleave', function() {
          stopImageRotation();
        });
      });
    });
  }

  function startImageRotation(collectionCards) {
    if (imageRotationInterval) {
      clearInterval(imageRotationInterval);
    }

    currentImageIndex = 0;
    rotateImages(collectionCards);

    imageRotationInterval = setInterval(() => {
      rotateImages(collectionCards);
    }, 3000);
  }

  function rotateImages(collectionCards) {
    collectionCards.forEach((item) => {
      const card = item.querySelector('.megamenu-collection-card');
      if (!card) return;

      const productImages = card.getAttribute('data-product-images');
      if (!productImages) return;

      const images = productImages.split('|').filter(i => i.trim());
      if (images.length === 0) return;

      const imageIndex = currentImageIndex % images.length;
      const imageUrl = images[imageIndex];
      const img = item.querySelector('.megamenu-collection-image img');

      if (img) {
        img.src = imageUrl + '?width=1200';
        img.classList.remove('lazyload');
      }
    });

    currentImageIndex++;
  }

  function stopImageRotation() {
    if (imageRotationInterval) {
      clearInterval(imageRotationInterval);
      imageRotationInterval = null;
      currentImageIndex = 0;
    }
  }
})();
